import { ArrowUpDown, ChevronDown, ChevronUp } from "lucide-react";

export function sortRows(rows, key, dir, getVal) {
  if (!key) return rows;
  const gv = getVal || ((r) => r[key]);
  return [...rows].sort((a, b) => {
    const va = gv(a) ?? "";
    const vb = gv(b) ?? "";
    const cmp = typeof va === "number" && typeof vb === "number" ? va - vb : String(va).localeCompare(String(vb));
    return dir === "desc" ? -cmp : cmp;
  });
}

export function matchSearch(row, q, keys) {
  if (!q) return true;
  const needle = String(q).toLowerCase();
  return keys.some((k) => String(row[k] ?? "").toLowerCase().includes(needle));
}

export function Th({ k, label, ts, className = "" }) {
  const active = ts.get("sort") === k;
  return (
    <th
      className={`cursor-pointer select-none py-2 pr-3 hover:text-slate-300 ${className}`}
      onClick={() => ts.toggleSort(k)}
      data-testid={`${ts.prefix}-sort-${k}`}
    >
      <span className="inline-flex items-center gap-1">
        {label}
        {active
          ? (ts.get("dir") === "asc" ? <ChevronUp className="h-3 w-3 text-[#00FF87]" /> : <ChevronDown className="h-3 w-3 text-[#00FF87]" />)
          : <ArrowUpDown className="h-2.5 w-2.5 opacity-40" />}
      </span>
    </th>
  );
}

export function TableToolbar({ ts, t, placeholder, children }) {
  return (
    <div className="mb-3 flex flex-wrap items-center gap-2">
      <input
        data-testid={`${ts.prefix}-search-input`}
        value={ts.get("q")}
        onChange={(e) => ts.set("q", e.target.value)}
        placeholder={placeholder || t("table.search")}
        className="w-full rounded-md border border-[#1F293D] bg-[#0B0E14] px-2.5 py-1.5 text-xs text-slate-200 focus:border-[#00FF87] focus:outline-none sm:w-56"
      />
      {children}
      <button
        data-testid={`${ts.prefix}-reset-button`}
        onClick={ts.reset}
        className="rounded-md border border-[#1F293D] px-2.5 py-1.5 font-mono2 text-[10px] uppercase tracking-wider text-slate-400 hover:border-[#00F0FF]/50 hover:text-[#00F0FF]"
      >
        {t("filters.reset")}
      </button>
    </div>
  );
}

export const filterSelectCls =
  "rounded-md border border-[#1F293D] bg-[#0B0E14] px-2 py-1.5 text-xs text-slate-300 focus:border-[#00FF87] focus:outline-none";
